/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/11/21
 */

import React from 'react';
import Login from '../pages/Login';
import { RouteProps } from 'react-router';
import { useAuth } from '../auth/useAuth';

const ProtectedRoute = (props: RouteProps) => {
    const { authState } = useAuth();
    if (!authState.isAuthenticated) {
        return <Login />;
    }

    return <>{props.element}</>;
};

export default ProtectedRoute;
